module.exports = __webpack_public_path__ + "static/media/coastview_marker_ic.23c43437.svg";